

















import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class PostCountBox extends Vue {
  @Prop({
    default: 0
  })
  likeCount?: number;
  @Prop({
    default: 0
  })
  commentCount?: number;
  @Prop({
    default: 0
  })
  viewCount?: number;
  @Prop({
    default: true
  })
  isVideo?: boolean;
}
